export default {
    namespaced: true,
    state: () => ({
        dailyCheckPage: { },
    }),
    getters: {
        dailyCheckPageName: (state) => (pageid) => {
            const page = state.dailyCheckPage.filter(obj => {
                return obj.dailyCheckPageId == pageid
            });
            
            if(!page[0]){
                return null;
            }

            if(page[0].dailyCheckPageNo == 21){
                return "フリーコメント";
            }

            return page[0].dailyCheckPageName;
        },
    },
    mutations: {
        setDailyCheckPage(state, list) {
            state.dailyCheckPage = list;
        },
    },
    actions: {
        set({ commit }, list) {
            commit('setDailyCheckPage', list )
        },
    },
}
